import { render, staticRenderFns } from "./extAttrPanel.vue?vue&type=template&id=c80cfd86&"
import script from "./extAttrPanel.vue?vue&type=script&lang=js&"
export * from "./extAttrPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports